export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" fill-rule="evenodd" d="M16.5 10a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-1.515 6.258a8 8 0 1 1 1.273-1.273l4.378 4.379a.9.9 0 1 1-1.272 1.272l-4.38-4.378Z" clip-rule="evenodd"/>
</svg>
`;
